import React, { ReactNode } from 'react';
import ReactDOM from "react-dom";
interface ModalProps {
    children: ReactNode;
    isOpen: boolean;
    onClose: () => void;
}
const Modal: React.FC<ModalProps> = ({ children, isOpen, onClose }) => {
    if (!isOpen) return null;
    return ReactDOM.createPortal(
        <>
            <div className="modal-overlay" style={modalStyles.overlay} onClick={onClose}>
                <div className="modal-content" style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
                    {children}
                </div>
            </div >
        </>, document.body
 
    )
}
const modalStyles: { overlay: React.CSSProperties; content: React.CSSProperties; } = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 999999
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        maxHeight: "100%",
        overflow: 'auto',
    }
};
 
export default Modal